import { makeStyles } from '@material-ui/core/styles';
import { Bogle_Light } from 'constants/constant';

const errorPage = makeStyles(() => ({
	formLabel: {
		width: (P) => (P.isSmallScreen ? 'auto' : '100%'),
		textAlign: 'center',
		fontSize: (P) => (P.isSmallScreen ? '20px' : '24px'),
		fontFamily: 'Bogle-Regular'
	},
	responsiveLabel: {
		lineHeight: '33.36px',
		fontSize: '24px',
		maxHeight: '24px',
		fontFamily: Bogle_Light,
		textAlign: 'center'
	},
	responsiveLabelSmall: {
		lineHeight: '24px',
		fontSize: '18px',
		maxHeight: '24px',
		fontFamily: Bogle_Light,
		textAlign: 'center'
	}
}));

export default errorPage;
